import React, { ReactNode } from 'react';
import { useTabsContext } from './Tabs';
import { StyledTabPanel } from './Tabs.styles';

export interface TabPanelProps {
  id: string;
  children: ReactNode;
  className?: string;
  keepMounted?: boolean;
}

const TabPanel: React.FC<TabPanelProps> = ({
  id,
  children,
  className,
  keepMounted = true
}) => {
  const context = useTabsContext();

  if (!context) {
    throw new Error('TabPanel must be used within a Tabs component');
  }

  const { activeTab } = context;
  const isActive = activeTab === id;

  if (!isActive && !keepMounted) {
    return null;
  }

  return (
    <StyledTabPanel
      role="tabpanel"
      aria-labelledby={`tab-${id}`}
      id={`tabpanel-${id}`}
      tabIndex={0}
      className={className}
      isActive={isActive}
    >
      {children}
    </StyledTabPanel>
  );
};

export default TabPanel;